import {AfterViewInit, Component, Input, LOCALE_ID, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {PermissionsService} from '../../../../../Services/permissions.service';
import {Router} from '@angular/router';
import {DataService} from '../../../../../Services/data.service';
import {ItemModel} from '../../../../../DataModels/item-model';
import {UomModel} from '../../../../../DataModels/uom-model';
import {ItemCategoryModel} from '../../../../../DataModels/item-category-model';
import {ItemTypeModel} from '../../../../../DataModels/item-type-model';
import {ItemGroupModel} from '../../../../../DataModels/item-group-model';
import {TaxModel} from '../../../../../DataModels/tax-model';
import {AccountModel} from '../../../../../DataModels/account-model';
import {debounceTime} from 'rxjs/operators';
import {ConfirmDialogService} from '../../../../../Services/confirm-dialog.service';
import {ResponseModel} from '../../../../../DataModels/response-model';
import {BsToastService} from '../../../../../Services/bs-toast-service';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-item-detail',
  templateUrl: './item-detail.component.html',
  styleUrls: ['./item-detail.component.css'],
  standalone: false
})
export class ItemDetailComponent implements OnInit, AfterViewInit {
  @Input() itemID: string;
  isSaveNew = false;
  originalSnapshot: any = {};
  uomList: UomModel[];
  itemCategoryList: ItemCategoryModel[];
  itemTypeList: ItemTypeModel[];
  itemGroupList: ItemGroupModel[];
  taxList: TaxModel[];
  accountList: AccountModel[];
  inventoryAccountList: any = [];
  uomCount = 0;
  itemCategoryCount = 0;
  itemTypeCount = 0;
  itemGroupCount = 0;
  taxListCount = 0;
  accountListCount = 0;
  margin = 0.0;
  profit = 0.0;
  markup = 0.0;

  itemInventory = false;
  submitted = false;

  public vm = {
    toDateSelect: [],
    dateError: false,
    report: [],
    itemInventory: false,
    item: {
      average_cost: 0,
      cost: 0,
      price: 0,
      most_recent_cost: 0,
      company_id: null,
      category_id: null,
      expense_account_id: null,
    },
    uomCountLoaded: false,
  };
  item: ItemModel;
  itemForm: UntypedFormGroup;

  constructor(
    private table: DataService,
    private notification: BsToastService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public p: PermissionsService,
    private confirmDialogService: ConfirmDialogService,
    private decimalPipe: DecimalPipe,
  ) {
    this.createForm();
  }

  createForm() {
    this.itemForm = this.formBuilder.group(
      {
        id: new UntypedFormControl(null),
        code: new UntypedFormControl(null),
        barcode: new UntypedFormControl(null),
        name: new UntypedFormControl(null),
        description: new UntypedFormControl(null),
        // inventory_item: new FormControl(null),
        price: new UntypedFormControl(null),
        cost: new UntypedFormControl(null, {validators: [Validators.required]}),
        // cost: this.decimalPipe.transform(0, '1.2-2'),
        category_id: new UntypedFormControl(null),
        item_type_id: new UntypedFormControl(null),
        item_group_id: new UntypedFormControl(null),
        uom_id: new UntypedFormControl(''),
        expense_account_id: new UntypedFormControl(null),
        inventory_account_id: new UntypedFormControl(null),
        payable_tax_1_id: new UntypedFormControl(null),
        payable_tax_2_id: new UntypedFormControl(null),
        receivable_tax_1_id: new UntypedFormControl(null),
        receivable_tax_2_id: new UntypedFormControl(null),
        revenue_account_id: new UntypedFormControl(null),
        UNNumber: new UntypedFormControl(null),
        ShippingName: new UntypedFormControl(null),
        PrimaryClass: new UntypedFormControl(null),
        SubsidiaryClass: new UntypedFormControl(null),
        PackingGroup: new UntypedFormControl(null),
        content_height: new UntypedFormControl(null),
        account: new UntypedFormControl(null),
        account1: new UntypedFormControl(null),
        account2: new UntypedFormControl(null),
        tax: new UntypedFormControl(null),
        tax1: new UntypedFormControl(null),
        tax2: new UntypedFormControl(null),
        tax3: new UntypedFormControl(null),
        uom: new UntypedFormControl(null),
        active: new UntypedFormControl(true),
        last_cost: new UntypedFormControl({value: '', disabled: true}),
        average_cost: new UntypedFormControl({value: '', disabled: true}),
      },
      {
        // must match stuff etc.
      }
    );
  }

  ngOnInit() {
    this.LoadUOM();
    this.loadTaxes();
    this.LoadItemCategory();
    this.LoadItemType();
    this.LoadItemGroup();
    this.loadAccount();
    if (this.itemID) {
      this.LoadData();
    } else {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }

    this.itemForm
      .get('price')
      .valueChanges.pipe(debounceTime(1000))
      .subscribe((data) => {
        this.calcMarginAndProfit();
      });

    this.itemForm
      .get('cost')
      .valueChanges.pipe(debounceTime(1000))
      .subscribe((data) => {
        this.calcMarginAndProfit();
      });

    // make sure they select and expense account if it is an inventory item
    this.itemForm.get('inventory_account_id').valueChanges.subscribe((val) => {
      const inventoryVal = this.itemForm.get('inventory_account_id').value;
      if (inventoryVal !== null && inventoryVal !== undefined && inventoryVal !== '') {
        // for setting validations
        this.itemForm.get('expense_account_id').setValidators(Validators.required);
      } else {
        // for clearing validations
        this.itemForm.get('expense_account_id').clearValidators();
      }
      this.itemForm.get('expense_account_id').updateValueAndValidity();
    });
  }

  ngAfterViewInit() {

  }

  get f() {
    return this.itemForm.controls;
  }

  Reset() {
    this.itemForm.reset();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [
      $localize`:Are you sure you want to delete item? @@areYouSureYouWantToDeleteItem:Are you sure you want to delete item?`,
      this.item.name,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.table.deleteDataById('item', this.itemID).subscribe(
          (result) => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
            this.router.navigateByUrl('/admin/item-list').then();
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            // this.OnClose();
          }
        );
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  onClose() {
    this.router.navigate(['admin/item-list']).then();
  }

  onSave(saveClose: boolean) {
    this.submitted = true;
    if (this.itemForm.invalid) {
      this.notification.showWarningToast($localize`:Form Errors! @@formErrors:Form Errors!`);
      // this.submitted = false;
      return;
    }
    // Ensure numeric fields are numbers before saving
    const rawPrice = this.itemForm.get('price')?.value;
    const rawCost = this.itemForm.get('cost')?.value;
    const priceNum = typeof rawPrice === 'number' ? rawPrice : parseFloat(String(rawPrice || '0').replace(/,/g, ''));
    const costNum = typeof rawCost === 'number' ? rawCost : parseFloat(String(rawCost || '0').replace(/,/g, ''));
    if (!isNaN(priceNum)) {
      this.itemForm.get('price')?.setValue(priceNum, {emitEvent: false});
    }
    if (!isNaN(costNum)) {
      this.itemForm.get('cost')?.setValue(costNum, {emitEvent: false});
    }

    this.item = Object.assign({}, this.itemForm.value);
    if (this.itemID) {
      if (this.itemForm.invalid === false) {
        this.table.patch('item', this.itemID, this.item).then(
          () => {
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            if (saveClose) {
              this.onClose();
            } else if (this.isSaveNew) {
              this.isSaveNew = false;
              this.itemID = null;
              this.Reset();
            }
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          }
        );
      }
    } else {
      this.table.postWithPromise('item', this.item).then((res) => {
        // stops double posting when clicking Save
        let apiReturn: any = [];
        if (typeof res === 'object') {
          apiReturn = JSON.parse(JSON.stringify(res));
        }
        this.itemID = apiReturn.id;
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
        if (saveClose) {
          this.onClose();
        } else if (this.isSaveNew) {
          this.isSaveNew = false;
          this.itemID = null;
          this.Reset();
        } else {
          // Default behavior for plain Save: navigate to the newly created record
          this.router.navigateByUrl('admin/item-form;id=' + this.itemID).then();
        }
      });

      // this.notification.success($localize`:Saved @@saved:Saved`);
    }
    this.submitted = false;
    return true;
  }

  private LoadData() {
    this.table.getData('item', this.itemID).subscribe({
      next:
        (result: ItemModel) => {
        this.item = result;

          // console.log('item record:');
          // console.log(this.item);
      },
      error: (err: any) => {
        console.error(err.message);
      },
      complete: () => {
        // console.log('complete');
        this.itemForm.patchValue(this.item);
        // Normalize display for decimal fields on load
        this.formatToTwoDecimals('price');
        this.formatToTwoDecimals('cost');
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      },
    });
  }

  private LoadUOM() {
    this.table.getData('uom?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.uomList = result.Data;
        this.uomCount = this.uomList.length;
        // this.vm.uomCountLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.notification.error(error.message);
        console.log(error);
      },
      () => {}
    );
  }

  private LoadItemCategory() {
    this.table.getData('item_category?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.itemCategoryList = result.Data;
        this.itemCategoryCount = this.itemCategoryList.length;
      },
      (error: HttpErrorResponse) => {
        // this.notification.error(
        //   $localize`:Error loading Item Categories @@errorLoadingItemCategories:Error loading Item Categories`
        // );
        console.log(error);
      },
      () => {}
    );
  }

  private LoadItemType() {
    this.table.getData('item_type?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.itemTypeList = result.Data;
        this.itemTypeCount = this.itemTypeList.length;
      },
      (error: HttpErrorResponse) => {
        // this.notification.error(
        //   $localize`:Error loading Item Categories @@errorLoadingItemCategories:Error loading Item Categories`
        // );
        console.log(error);
      },
      () => {}
    );
  }

  private LoadItemGroup() {
    this.table.getData('item_group?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.itemGroupList = result.Data;
        this.itemGroupCount = this.itemGroupList.length;
      },
      (error: HttpErrorResponse) => {
        // this.notification.error(
        //   $localize`:Error loading Item Categories @@errorLoadingItemCategories:Error loading Item Categories`
        // );
        console.log(error);
      },
      () => {}
    );
  }

  private loadTaxes() {
    this.table.getData('tax?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.taxList = result.Data;
        this.taxListCount = this.taxList.length;
      },
      (error: HttpErrorResponse) => {
        // this.notification.error($localize`:Error loading users @@errorLoadingUsers:Error loading users`);
        console.log(error);
      },
      () => {}
    );
  }

  private loadAccount() {
    this.table.getData('account?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.accountList = result.Data.sort((a: any, b: any) => a.number - b.number);
        // this.accountList = result.Data;
        this.accountListCount = this.accountList.length;
        // filter list down to inv accounts for inv acct dropdown
        for (const item of this.accountList as any) {
          if (item.id === 'in') {
            this.inventoryAccountList.push(item);
          }
        }
      },
      (error: HttpErrorResponse) => {
        // this.notification.error($localize`:Error loading users @@errorLoadingUsers:Error loading users`);
        console.log(error);
      },
      () => {}
    );
  }

  /*
      () => {
        this.totalQuantity = 0;
        this.totalBalance = 0;
        // vm.getting = false;
        //  for (let x = 0; x < result.length; x++) {
        //    this.totalQuantity += Number(temp.balances[x].quantity);
        //     this.totalBalance += Number(temp.balances[x].balance);
      };
*/
  /*

  Profit
   <!--span *ngIf="!vm.item.average_cost">{{(item.price - item.cost) | number:'1.2-2' }}</span>
        <span *ngIf="vm.item.average_cost">{{(item.price - average_cost) | number:'2' }}</span -->

   margin
      <!--span *ngIf="!vm.item.average_cost">{{(item.price - item.cost) / item.price * 100 | number:'1.2-2'}}%</span>
        <span *ngIf="vm.item.average_cost">{{(item.price - item.average_cost) / item.price * 100 | number:'1.2-2'}}
          %</span -->
   markup
     <!--span *ngIf="!vm.item.average_cost">{{(item.price - item.cost) / item.cost * 100 | number:'1.2-2'}}%</span>
        <span *ngIf="vm.item.average_cost">{{(item.price - item.average_cost) / item.cost * 100 | number:'1.2-2'}}
          %</span-->
   */

  buildSnapshot(): any {
    try {
      return this.itemForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  formatToTwoDecimals(controlName: string): void {
    const ctrl = this.itemForm.get(controlName);
    if (!ctrl) {
      return;
    }
    const raw = ctrl.value;
    if (raw === null || raw === undefined || raw === '') {
      // Leave empty
      this.calcMarginAndProfit();
      return;
    }
    const num = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(/,/g, ''));
    if (isNaN(num)) {
      ctrl.setValue('', {emitEvent: false});
      this.calcMarginAndProfit();
      return;
    }
    // Format with thousands separators and 2 decimals for display
    const formatted = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    }).format(num);
    // Set as a string to preserve trailing zeros visually in the input
    ctrl.setValue(formatted, {emitEvent: false});
    this.calcMarginAndProfit();
  }

  // Remove grouping separators on focus so users can edit easily
  stripSeparators(controlName: string): void {
    const ctrl = this.itemForm.get(controlName);
    if (!ctrl) {
      return;
    }
    const raw = ctrl.value;
    if (raw === null || raw === undefined || raw === '') {
      return;
    }
    const stripped = String(raw).replace(/,/g, '');
    ctrl.setValue(stripped, {emitEvent: false});
  }

  private calcMarginAndProfit() {
    const priceRaw = this.itemForm.get('price')?.value;
    const costRaw = this.itemForm.get('cost')?.value;
    const price = typeof priceRaw === 'number' ? priceRaw : parseFloat(String(priceRaw || '0').replace(/,/g, '')) || 0;
    const cost = typeof costRaw === 'number' ? costRaw : parseFloat(String(costRaw || '0').replace(/,/g, '')) || 0;

    this.profit = +(price - cost).toFixed(2);
    this.margin = price > 0 ? +(((price - cost) / price) * 100).toFixed(2) : 0;
    this.markup = cost > 0 ? +(((price - cost) / cost) * 100).toFixed(2) : 0;
  }

  protected readonly Number = Number;
}
